import { render, staticRenderFns } from "./ExpiredToken.vue?vue&type=template&id=44a98155&scoped=true&"
import script from "../../services/applicant/expired-token.js?vue&type=script&lang=js&"
export * from "../../services/applicant/expired-token.js?vue&type=script&lang=js&"
import style0 from "./ExpiredToken.vue?vue&type=style&index=0&id=44a98155&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a98155",
  null
  
)

export default component.exports